import { __read } from 'tslib';
import { useState, useEffect } from 'react';

var lastPageKey = 'marcom-lastPage';
var useLastInternalPage = function (_a) {
    var router = _a.router;
    var _b = __read(useState(), 2), lastPage = _b[0], setLastPage = _b[1];
    useEffect(function () {
        if (typeof window === 'undefined' || !router)
            return;
        var currentPage = window.location.origin + router.asPath;
        var savedLastPage = window.sessionStorage.getItem(lastPageKey);
        if (savedLastPage) {
            setLastPage(savedLastPage);
        }
        window.sessionStorage.setItem(lastPageKey, currentPage);
    }, [router === null || router === void 0 ? void 0 : router.asPath]);
    return !router ? lastPage : null;
};

export { useLastInternalPage as default };
//# sourceMappingURL=useLastInternalPage.esm.js.map
